import commonApi from "@api/common";
import subscriptionApi from "@api/subscription";
import { useLayoutContext } from "@context/layout";
import {
  ISubscriptionRecommenderExperiment,
  SUBS_ACTION_TYPE,
  SUBSCRIPTION_ACTION,
  SubscriptionRecommenderPositions,
  TAG_EXPERIMENT,
} from "@types";
import { useRouter } from "next/router";
import { useCallback } from "react";
import useRequestImmutable from "./useRequestImmutable";

const useSubscriptionExperiments = () => {
  const { userData } = useLayoutContext();
  const isLoggedIn = !!userData?.is_login;

  const { data: activePlansData } = useRequestImmutable(
    isLoggedIn ? subscriptionApi.checkUserPlan() : null
  );
  const { asPath } = useRouter();

  const getPlanId = (inputPlanId?: number | null) => {
    if (inputPlanId !== undefined && inputPlanId !== null) {
      return inputPlanId;
    }

    if (activePlansData?.data?.is_active) {
      return activePlansData.data.plan_id;
    }

    return null;
  };

  const handleLogExperimentSubsPage = (data: {
    action: SUBSCRIPTION_ACTION;
    category_id?: number | null;
    question_index?: number | null;
    plan_id?: number | null;
  }) => {
    const previousUrl =
      typeof window !== "undefined" ? document.referrer : null;

    commonApi
      .submitLog({
        tag: TAG_EXPERIMENT.SUBSCRIPTION_PAGE,
        anyJoson: {
          is_login: isLoggedIn,
          user_id: userData?.user_id ?? null,
          referrer_url: previousUrl,
          action: data.action,
          plan_id: getPlanId(data.plan_id),
          category_id: data.category_id ?? null,
          question_index: data.question_index ?? null,
        },
      })
      .fetch()
      .catch((err) => {
        console.error("Experiment log failed:", err);
      });
  };
  const handleLogExperimentSubRecommender = useCallback(
    async ({
      position,
      action = SUBS_ACTION_TYPE.CLICK,
    }: {
      position: SubscriptionRecommenderPositions;
      action?: SUBS_ACTION_TYPE;
    }) => {
      const subscriptionStats = userData?.subscription || null;

      const revenue = subscriptionStats?.revenue || null;
      const similarity = subscriptionStats?.similarity || null;

      const revenueFields = {
        user_age_days: revenue?.user_age_days ?? userData?.user?.age ?? null,
        last_year_revenue_irt: revenue?.last_year_revenue_irt ?? null,
        estimated_year_revenue_irt: revenue?.estimated_year_revenue_irt ?? null,
        first_order_age_days: revenue?.first_order_age_days ?? null,
        last_order_age_days: revenue?.last_order_age_days ?? null,
        revenue_observation_days: revenue?.revenue_observation_days ?? null,
      };

      const similarityFields = {
        final_score: similarity?.final_score ?? null,
        average_similarity: similarity?.average_similarity ?? null,
        max_similarity: similarity?.max_similarity ?? null,
      };

      const payload: ISubscriptionRecommenderExperiment = {
        tag: TAG_EXPERIMENT.SUBSCRPTION_RECOMMENDER,
        anyJson: {
          action: action,
          is_login: Boolean(userData?.is_login),
          page_url: asPath,
          position: position,
          user_id: userData?.user_id ?? null,

          ...revenueFields,
          ...similarityFields,
        },
      };

      try {
        const res = await commonApi.submitLog(payload).fetch();
        return res;
      } catch (error) {
        console.log(error);
      }
    },
    [userData, asPath]
  );

  return { handleLogExperimentSubsPage, handleLogExperimentSubRecommender };
};

export default useSubscriptionExperiments;
